import React, { useContext, useState, useEffect } from 'react'
import { Form, Row, Col, Button, Table } from 'react-bootstrap'
import { Loading, TablePagination } from '../Library'
import { LanguageContext } from '../Language/LanguageContext'
import DatePicker from "react-datepicker";
import { adminDashboard, adminLog } from '../Network/Administration'
import dayjs from 'dayjs'
import { NotifyContext } from "../Library/Notify"
import { setDocumentTitle } from '../AppTitle'
import "./ActivityLog.css"

function ActivityLog() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.activity_log
    const notify = useContext(NotifyContext)

    const [isLoading, setLoading] = useState(false)
    const [activityData, setActivityData] = useState([]) 
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [type, setType] = useState("")

    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 15
    const totalPage = Math.ceil(activityData.length / perPage)
    const indexOfLast = currentPage * perPage
    const indexOfFirst = indexOfLast - perPage

    const typeData = [
        { value: "User", label: "User" },
        { value: "Company", label: "Company" },
        { value: "Department", label: "Department" },
        { value: "Inbox", label: "Inbox" },
        { value: "News", label: "News" },
        { value: "Gallery", label: "Gallery" },
        { value: "Calendar", label: "Calendar" },
        { value: "Content", label: "Content" },
        { value: "Service Task", label: "Service Task" },
        { value: "Role", label: "Role" },
        { value: "Import", label: "Import" },
        { value: "Export", label: "Export" }
    ]

    const fetchData = (startDate, endDate, type) =>{
        setLoading(true)
        adminLog(startDate, endDate, type,
            (data)=>{
                setActivityData(data)
                setLoading(false)
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            })
    }

    const previewFilter = () =>{
        fetchData(startDate, endDate, type)
        setCurrentPage(1)
    }

    const clearFilter = () =>{
        fetchData(null, null, "")
        setStartDate(null)
        setEndDate(null)
        setType("")
        
    }

    useEffect(()=>{
        const firstfetchData = (startDate, endDate, type) =>{
            setLoading(true)
            adminLog(startDate, endDate, type,
                (data)=>{
                    setActivityData(data)
                    setLoading(false)
                },
                (error)=>{
                    notify.showNotify("Something wrong", error.message, 2)
                    setLoading(false)
                })
        }

        setDocumentTitle("Log")
        firstfetchData(startDate, endDate, type)
    },[])

    return (
        <div id="activity-log">
            { isLoading ? <Loading/>: null }
            <div>{lang.log_desc}</div>
            <div className="filter-section">
                <Row>
                    <Col lg={4}>
                        <Form.Group>
                            <Form.Label>{lang.start_datetime}</Form.Label>
                            <DatePicker
                            className="form-control"
                            showTimeSelect
                            selected={startDate}
                            onChange={(date)=>setStartDate(date)}
                            dateFormat="d MMMM yyyy H:mm"
                            maxDate={new Date()}
                            placeholderText={lang.choose_datetime}
                            />
                        </Form.Group> 
                    </Col>
                    <Col lg={4}>
                        <Form.Group>
                            <Form.Label>{lang.end_datetime}</Form.Label>
                            <DatePicker
                            className="form-control"
                            showTimeSelect
                            selected={endDate}
                            onChange={(date)=>setEndDate(date)}
                            dateFormat="d MMMM yyyy H:mm"
                            minDate={startDate}
                            maxDate={new Date()}
                            placeholderText={lang.choose_datetime}
                            />
                        </Form.Group> 
                    </Col>
                    <Col lg={4}>
                        <Form.Group>
                            <Form.Label>{lang.type}</Form.Label>
                            <Form.Control 
                            as="select" 
                            value={type}
                            onChange={(e)=>setType(e.target.value)}>
                                <option value="">{lang.choose_type}</option>
                                { typeData.map((item, key)=>
                                <option value={item.value} key={key}>{item.label}</option>
                                )}
                            </Form.Control>
                        </Form.Group> 
                    </Col>
                </Row>
                <div>
                    <Button style={{marginRight: 10}} onClick={()=>previewFilter()}>
                        {lang.preview}
                    </Button>
                    <Button variant="secondary" onClick={()=>clearFilter()}>
                        {lang.clear}
                    </Button>
                </div>
            </div>
            <div className="table-container">
                <Table hover>
                    <thead>
                        <tr>
                            <th></th>
                            <th className="activity-name-col">{lang.activity_name}</th>
                            <th>{lang.type}</th>
                            <th>{lang.user}</th>
                            <th>{lang.datetime}</th>
                            {/* <th>{lang.action}</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        { activityData.slice(indexOfFirst, indexOfLast).map((item, key)=>
                        <ActivityRow
                        key={key}
                        no={item.id}
                        activityName={item.activityName}
                        type={item.type}
                        user={`${item.user.firstName} ${item.user.lastName}`}
                        datetime={item.time}
                        priority={item.priority}
                        />
                        )}
                        { activityData.length === 0 ?
                        <tr style={{ textAlign: 'center' }}>
                            <td colSpan={6}>{lang.no_activity_log}</td>
                        </tr>
                        : null
                        }
                    </tbody>
                </Table>
                
            </div>
            <div>
                <TablePagination
                dataLength={totalPage}
                size={10}
                currentPage={currentPage}
                handlerPaginationClick={(page)=>{ setCurrentPage(page) }}
                nextClick={()=>{ setCurrentPage(currentPage + 1) }}
                prevClick={()=>{ setCurrentPage(currentPage - 1) }}
                firstPageClick={(first)=>{ setCurrentPage(first) }}
                lastPageClick={(last)=>{ setCurrentPage(last) }}
                disabledPrev={currentPage === indexOfFirst + 1}
                disabledNext={currentPage === totalPage}
                />
            </div>
        </div>
    )
}

function ActivityRow({ no, priority, activityName, type, user, datetime, onClickDelete }){
    let priorityColor
    switch (priority) {
        case 1:
            priorityColor = "red"
            break;
        case 2:
            priorityColor = "orange"
            break;
        case 3:
            priorityColor = "limegreen"
            break;
        default:
            priorityColor = "grey"
            break;
    }

    return(
        <tr>
            <td>
                <div className="priority-indicator" style={{backgroundColor: priorityColor}}></div>
            </td>
            <td className="activity-name-col">{activityName}</td>
            <td>{type}</td>
            <td>{user}</td>
            <td>{dayjs(datetime).format("D MMMM YYYY H:mm")}</td>
        </tr>
    )
}

export default ActivityLog
